import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import InputField from '../../../../components/fields/InputField';
import { colSpan } from '../../WebpageDetailsPage/WebpageBlock/ColumnListBlock';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

const MaintainenceModuleMainDetailsForm = () => {
    const { t } = useTranslation(['moduleDetails', 'maintenance']);

    return (
        <StyledContainer gutter={10}>
            <Col {...colSpan}>
                <InputField
                    {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                    name="displayName"
                    required
                />
            </Col>
        </StyledContainer>
    );
};

export default MaintainenceModuleMainDetailsForm;
